"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getLoginLink: ()=>getLoginLink,
    redirectToLogout: ()=>redirectToLogout,
    logout: ()=>logout
});
const external_jwt_service_js_namespaceObject = require("./jwt.service.js");
const getLoginLink = function(uniqueKey) {
    let next = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.location.href;
    return external_jwt_service_js_namespaceObject.bytecloudJwtService.getService(uniqueKey).getLoginLink(next);
};
const redirectToLogout = (uniqueKey, next)=>external_jwt_service_js_namespaceObject.bytecloudJwtService.getService(uniqueKey).redirectToLogout(next);
const logout = (uniqueKey, next)=>external_jwt_service_js_namespaceObject.bytecloudJwtService.getService(uniqueKey).logout(next);
exports.getLoginLink = __webpack_exports__.getLoginLink;
exports.logout = __webpack_exports__.logout;
exports.redirectToLogout = __webpack_exports__.redirectToLogout;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getLoginLink",
    "logout",
    "redirectToLogout"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
